import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function SSOCallback() {
  const [searchParams] = useSearchParams();
  const { provider: pathProvider } = useParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const provider = pathProvider || searchParams.get("provider");
      const code = searchParams.get("code");
      const redirectUri = window.location.origin + window.location.pathname;

      try {
        let res;
        if (provider === "google") {
          if (!code) throw new Error("Missing code parameter");
          res = await api.post("/auth/google/callback", { code, redirect_uri: redirectUri });
        } else if (provider === "discord") {
          if (!code) throw new Error("Missing code parameter");
          res = await api.post("/auth/discord/callback", { code, redirect_uri: redirectUri });
        } else if (provider === "steam") {
          const steamParams = {};
          searchParams.forEach((val, key) => {
            steamParams[key] = val;
          });
          res = await api.post("/auth/steam/callback", { params: steamParams });
        } else {
          throw new Error("Unknown provider: " + provider);
        }

        if (res.data?.token) {
          localStorage.setItem("tf_token", res.data.token);
          setUser(res.data.user);
          toast.success("Logged in successfully!");
          navigate("/");
        } else {
          throw new Error("No token returned from server");
        }
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login");
      }
    };
    handleCallback();
  }, [searchParams, navigate, setUser]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] space-y-4">
      <div className="animate-spin w-8 h-8 border-4 border-[var(--tf-primary)] border-t-transparent rounded-full" />
      <p className="text-zinc-400 tf-mono text-xs">Authenticating with provider...</p>
    </div>
  );
}
